import '../css/home.css';
import Content from './Content';



function Home() {
  return (<>
    <Content />
  </>);
}

export default Home;
